// DS: I78
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const Plus = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 8 8"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4.75,3.25 L7,3.25 L7,4.75 L4.75,4.75 L4.75,7 L3.25,7 L3.25,4.75 L1,4.75 L1,3.25 L3.25,3.25 L3.25,1 L4.75,1 L4.75,3.25 Z"
    })));
Plus.displayName = 'Plus';
export default Plus;

//# sourceMappingURL=Plus.js.map